import Utenze from "../../common/components/utenze/components/Utenze"
import Collaborazioni from "../../common/components/collaborazioni/components/Collaborazioni"
import Calendario from "../../common/components/calendario/components/Calendario"
import Mastello from "../../common/components/mastello/components/Mastello"
import QrCode from "../../common/components/qrCode/components/QrCode"
import RichiestaIngombranti from "../../common/components/richiestaIngombranti/components/RichiestaIngombranti"
import TipologiaSpazzatura from "../../common/components/tipologiaSpazzatura/components/TipologiaSpazzatura"
import Utente from "../../common/components/utente/components/Utente"
import DashboardComune from "../../common/components/dashboard/comune"
import Operatori from "../../common/components/operatori/components/Operatori"
import ProfiloComune from "../../common/components/profilo"
import Dispositivo from "../../common/components/dispositivi/components/Dispositivo"
import Pesata from "../../common/components/pesata/components/Pesata"
import Enti from "../../common/components/enti/components/Enti"
import Raccolta from "../../common/components/raccolta/components/Raccolta"
import Scontistica from "../../common/components/scontistica/components/Scontistica"


const comuneRoutes = [
    {
        path: "/dashboard",
        name: "Home",
        icon: "",
        component: DashboardComune,
        layout: "/comune",
        icon: "faHome"
    },
    {
        path: "/profilo",
        name: "Profilo",
        icon: "",
        component: ProfiloComune,
        layout: "/comune",
        icon: "faHome"
    },
    {
        path: "/utenze",
        name: "Utenze",
        icon: "",
        component: Utenze,
        layout: "/comune",
        icon: "faHome"
    },
    {
        path: "/utenti",
        name: "Utenti",
        icon: "",
        component: Utente,
        layout: "/comune",
        icon: "faUser"
    },
    {
        path: "/gestione-pesata",
        name: "Gestione Pesata",
        icon: "",
        component: Raccolta,
        layout: "/comune",
        icon: "faHome"
    },
    {
        path: "/gestione-tariffe-scontistica",
        name: "Gestione Tariffe",
        icon: "",
        component: Scontistica,
        layout: "/comune",
        icon: "faHome"
    },
    {
        path: "/enti",
        name: "Enti",
        icon: "",
        component: Enti,
        layout: "/comune",
        icon: "faCalendar"
    },
    {
        path: "/collaborazioni",
        name: "Collaborazioni",
        icon: "",
        component: Collaborazioni,
        layout: "/comune",
        icon: "faCalendar"
    },
    {
        path: "/calendari",
        name: "Calendari",
        icon: "",
        component: Calendario,
        layout: "/comune",
        icon: "faCalendar"
    },
    {
        path: "/mastelli",
        name: "Mastelli",
        icon: "",
        component: Mastello,
        layout: "/comune",
        icon: "faCalendar"
    },
    {
        path: "/qrCodes",
        name: "QrCodes",
        icon: "",
        component: QrCode,
        layout: "/comune",
        icon: "faCalendar"
    },
    {
        path: "/richieste-ingombranti",
        name: "Richieste Ingombranti",
        icon: "",
        component: RichiestaIngombranti,
        layout: "/comune",
        icon: "faCalendar"
    },
    // {
    //     path: "/tipologia-spazzatura",
    //     name: "Tipologie Spazzatura",
    //     icon: "",
    //     component: TipologiaSpazzatura,
    //     layout: "/comune",
    //     icon: "faCalendar"
    // },
    {
        path: "/operatori",
        name: "Operatori",
        icon: "",
        component: Operatori,
        layout: "/comune",
        icon: "faCalendar"
    },
    {
        path: "/dispositivi",
        name: "Dispositivi",
        icon: "",
        component: Dispositivo,
        layout: "/comune",
        icon: "faCalendar"
    }
]

export default comuneRoutes